import { IFilterItemV2 } from "#src/commonV2/Table/Filter/types";
import { File06, Folder } from "@untitled-ui/icons-react";
import { ReactComponent as FileX } from "#src/assets/images/v2/file-X.svg";
import { ReactComponent as FilePdf } from "#src/assets/images/v2/file-PDF.svg";
import { ReactComponent as FileP } from "#src/assets/images/v2/file-P.svg";
import i18next from "i18next";
import { SensitivityEnum } from "#src/components/endpoint/dlp/dataLabeling/Sensitivity";

const fixedTFunc = i18next.getFixedT(
  null,
  "endpoint",
  "devices.drive.table.filter"
);

export const fileTypeItems: IFilterItemV2[] = [
  {
    key: "folder",
    value: "folder",
    getLabel: () => fixedTFunc("type.folder"),
    leftIcon: <Folder className="h-5 w-5 min-w-5 text-gray-v2" />,
  },
  {
    key: "textDocument",
    value: ".doc,.docs,.odt,.ott,.pages",
    getLabel: () => fixedTFunc("type.textDocument"),
    leftIcon: <File06 className="h-5 w-5 min-w-5 text-gray-v2" />,
  },
  {
    key: "spreadsheet",
    value: ".xls,.xlsx,.csv,.ods,.numbers",
    getLabel: () => fixedTFunc("type.spreadsheet"),
    leftIcon: <FileX className="h-5 w-5 min-w-5 text-gray-v2" />,
  },
  {
    key: "pdf",
    value: "pdf",
    getLabel: () => fixedTFunc("type.pdf"),
    leftIcon: <FilePdf className="h-5 w-5 min-w-5 text-gray-v2" />,
  },
  {
    key: "presentation",
    value: ".ppt,.pptx,.odp,.key",
    getLabel: () => fixedTFunc("type.presentation"),
    leftIcon: <FileP className="h-5 w-5 min-w-5 text-gray-v2" />,
  },
];

export const fileSensitivityItems: IFilterItemV2[] = [
  {
    key: "highly_confidential",
    value: SensitivityEnum.HIGHLY_CONFIDENTIAL,
    getLabel: () => fixedTFunc("sensitivity.highlyConfidential"),
  },
  {
    key: "confidential",
    value: SensitivityEnum.CONFIDENTIAL,
    getLabel: () => fixedTFunc("sensitivity.confidential"),
  },
  {
    key: "internal",
    value: SensitivityEnum.INTERNAL,
    getLabel: () => fixedTFunc("sensitivity.internal"),
  },
  {
    key: "public",
    value: SensitivityEnum.PUBLIC,
    getLabel: () => fixedTFunc("sensitivity.public"),
  },
  {
    key: "notApplicable",
    value: SensitivityEnum.NOT_APPLICABLE,
    getLabel: () => fixedTFunc("sensitivity.notApplicable"),
  },
];
